<template>
  <div class="page-list" tabindex="0" @focus="focus" @keyup.enter="keyup" ref="pagelist">
    <div v-for="page in pages" :ref="`page${page.pageNumber}`" :data-active="isActive(page.pageNumber)" :key="page.pageNumber" class="page">
      <a href="#" :tabindex="tabIndex" @click.prevent="clickPage($event, page)">
        <PageThumb class="page-thumb" :page="page" />
        {{ page.pageNumber }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageThumb from './PageThumb'
export default {
  data () {
    return {
      active: false,
      click: false,
      tabIndex: -1
    }
  },
  activated () {
    this.scrollToActive()
    this.active = true
  },
  deactivated () {
    this.active = false
  },
  methods: {
    scrollToActive () {
      const el = (this.$refs[`page${this.pageNumber}`] || [])[0]
      if (el !== undefined && el !== null) {
        this.$refs.pagelist.parentElement.parentElement.scrollTop = el.offsetTop
        this.$refs.pagelist.parentElement.parentElement.scrollTop -= 40
      }
    },
    isActive (pageNumber) {
      pageNumber = Number(pageNumber)
      if (this.$store.getters.spread) {
        return (this.evenPage !== null && this.evenPage.pageNumber === pageNumber) || (this.oddPage !== null && this.oddPage.pageNumber === pageNumber)
      } else {
        return this.pageNumber === pageNumber
      }
    },
    clickPage (event, page) {
      event.stopPropagation()
      this.click = true
      this.$router.push({ name: 'Page', params: { pageNumber: page.pageNumber } })
    },
    focus () {
      this.tabIndex = -1
    },
    keyup () {
      this.tabIndex = 0
    }
  },
  computed: {
    ...mapGetters([
      'pages',
      'evenPage',
      'oddPage'
    ]),
    pageNumber () {
      return this.$route.params.pageNumber
    }
  },
  watch: {
    '$store.getters.leftMenuOpen' (newVal) {
      if (newVal && this.active) {
        this.scrollToActive()
      }
    },
    pageNumber () {
      if (this.active && !this.click) {
        setTimeout(() => {
          this.scrollToActive()
        }, 100)
      }
      this.click = false
    }
  },
  components: {
    PageThumb
  }
}
</script>

<style lang="scss">

</style>
